__turbopack_context__.v({
  "container": "vp8xYa_container",
  "decorator": "vp8xYa_decorator",
  "error": "vp8xYa_error",
  "fieldset": "vp8xYa_fieldset",
  "legend": "vp8xYa_legend",
  "medium": "vp8xYa_medium",
  "small": "vp8xYa_small",
});
